import React, {ReactNode, forwardRef} from 'react';
import styled, {css} from 'styled-components';
import {tabletAndUp} from '../../../constants/customMedia';
import {Text} from '../../atoms/Text/Text';

interface EmptyStateProps {
  title: ReactNode;
  subtitle?: ReactNode;
  'data-testid'?: string;
  asset?: ReactNode;
  cta?: ReactNode;
  className?: string;
}

export const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  ({asset, title, subtitle, cta, ...rest}, ref) => {
    return (
      <Container ref={ref} {...rest}>
        {asset}
        <BodyContainer>
          <div>{title}</div>
          <SubTextWrapper>
            <Text color="Grey1">{subtitle}</Text>
          </SubTextWrapper>
          <CTAWrapper>{cta}</CTAWrapper>
        </BodyContainer>
      </Container>
    );
  },
);

const CTAWrapper = styled.div`
  margin-top: 1.5rem;
`;

const SubTextWrapper = styled.div`
  margin-top: 0.5rem;
  ${tabletAndUp(css`
    max-width: 300px;
  `)}
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  ${tabletAndUp(css`
    text-align: initial;
  `)}
`;

const Container = styled.div`
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  justify-content: center;

  ${tabletAndUp(css`
    flex-direction: row;
    align-items: normal;
    gap: 3rem;
  `)}
`;
